<template>
    <q-page class="q-pa-md">

        <q-dialog class="rounded-borders" v-model="dialogVehiculo" persistent>
            <q-card style="width: 1200px; max-width: 80vw;" class="shadow-0">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Vehiculo</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <q-card class="shadow-0" v-if="auto">
                        <q-card-section>
                            <div class="row q-col-gutter-sm">
                                <div class="col-12 col-md-12">
                                    <q-input v-model="auto.agencia" outlined label="Agencia" dense required readonly />
                                </div>
                                <div class="col-12 col-md-4">
                                    <q-input v-model="auto.marca" outlined label="Nombre de marca" dense required
                                        readonly />
                                </div>
                                <div class="col-12 col-md-4">
                                    <q-input v-model="auto.modelo" outlined label="Modelo" dense required readonly />
                                </div>

                                <div class="col-12 col-md-4">
                                    <q-input v-model="auto.version" outlined label="Version" dense required readonly />
                                </div>
                                <div class="col-12 col-md-4">
                                    <q-input v-model="auto.tipoVehiculo" outlined label="Tipo de Vehiculo" dense
                                        required readonly />
                                </div>
                                <div class="col-12 col-md-4">
                                    <q-input v-model="auto.anio" outlined label="Año" dense required readonly />
                                </div>
                                <div class="col-12 col-md-4">
                                    <q-input v-model="auto.color" outlined label="Color" dense required readonly />
                                </div>
                            </div>
                        </q-card-section>
                        <q-separator class="q-mt-md" />
                        <q-card-section>
                            <div class="row q-col-gutter-sm">
                                <div class="col-12 col-md-4">
                                    <q-input readonly v-model="auto.numeroSerie" outlined label="Número de Serie" dense
                                        required />
                                </div>
                                <div class="col-12 col-md-4">
                                    <q-input readonly v-model="auto.numeroMotor" outlined label="Número de Motor" dense
                                        required />
                                </div>

                                <div class="col-12 col-md-4">
                                    <q-input readonly v-model="auto.placa" outlined label="Placa" dense required />
                                </div>
                                <div class="col-12 col-md-6">
                                    <q-input readonly v-model="auto.estadoPlaca" outlined label="Estado (Origen)" dense
                                        required />
                                </div>
                                <div class="col-12 col-md-6">
                                    <q-input readonly class="q-ma-none q-pa-none" dense outlined
                                        v-model="auto.fechaadquisicion" label="Fecha de Adquisición" mask="date"
                                        bottom-slots placeholder="yyyy/MM/dd">
                                        <template v-slot:after>
                                            <q-icon name="event" class="q-ma-none q-pa-none cursor-pointer">

                                            </q-icon>
                                        </template>
                                    </q-input>
                                </div>
                                <div class="col-12 col-md-12">
                                    <q-input readonly v-model="auto.beneficionproveedor" outlined label="Notas" dense
                                        required />
                                </div>
                            </div>
                        </q-card-section>

                    </q-card>
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-dialog class="rounded-borders" v-model="dialogDetalles" persistent>
            <q-card style="width: 1100px; max-width: 80vw;">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Localizador</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>

                <q-card-section class="row items-center q-pb-none q-col-gutter-md ">

                    <div class="col-12">
                        <q-select outlined v-model="selectCliente" :options="clientes" label="Cliente"
                            option-label="rfc" dense required emit-value map-options
                            @input="GetVehiculosPorClienteAsync">
                            <template v-slot:option="scope">
                                <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                    <q-item-section avatar>
                                        <q-icon name="mdi-account" color="priamry" />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label v-html="scope.opt.rfc + ' ' + scope.opt.razon_social" />
                                    </q-item-section>
                                </q-item>
                            </template>
                        </q-select>
                    </div>

                    <div class="col-12">
                        <q-select outlined v-model="selectAuto" :options="autosCliente" label="Vehículo"
                            option-label="texto" option-value="id" dense emit-value map-options>
                            <template v-slot:option="scope">
                                <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                    <q-item-section avatar>
                                        <q-icon name="mdi-car" color="priamry" />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label>{{ scope.opt.marca }} {{ scope.opt.modelo }} ({{ scope.opt.anio
                                        }})</q-item-label>
                                        <q-item-label caption>Placa: {{ scope.opt.placa }}</q-item-label>
                                    </q-item-section>
                                </q-item>
                            </template>
                        </q-select>
                    </div>

                    <div class="col-12 col-md-12">
                        <q-select dense outlined v-model="selectAgencia" :options="listaAgencias" label="Proveedor"
                            color="primary" option-label="razon_social" clearable
                            options-selected-class="text-deep-blue">
                            <template v-slot:option="scope">
                                <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                    <q-item-section avatar>
                                        <q-icon name="mdi-car" color="priamry" />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label v-html="scope.opt.rfc + ' - ' + scope.opt.razon_social" />
                                        <q-item-label caption>{{ scope.opt.representante
                                            }}</q-item-label>
                                    </q-item-section>
                                </q-item>
                            </template>
                        </q-select>
                    </div>

                    <div class="col-12 col-md-3">
                        <q-input class="q-pb-none" dense outlined v-model="fecha_compra" label="Fecha de Compra"
                            mask="date" bottom-slots placeholder="yyyy/MM/dd">
                            <template v-slot:after>
                                <q-icon name="event" class="q-ma-none q-pa-none cursor-pointer">
                                    <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy" transition-show="scale"
                                        transition-hide="scale">
                                        <q-date class="q-ma-none q-pa-none" v-model="fecha_compra">
                                            <div class="row items-center justify-end q-ma-none q-pa-none">
                                                <q-btn v-close-popup label="Ok" color="primary"
                                                    class="q-ma-none q-pa-none" flat />
                                            </div>
                                        </q-date>
                                    </q-popup-proxy>
                                </q-icon>
                            </template>
                        </q-input>
                    </div>

                    <div class="col-12 col-md-3">
                        <q-input class="q-pb-none" dense outlined v-model="fecha_instalacion"
                            label="Fecha de Instalación" mask="date" bottom-slots placeholder="yyyy/MM/dd">
                            <template v-slot:after>
                                <q-icon name="event" class="q-ma-none q-pa-none cursor-pointer">
                                    <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy" transition-show="scale"
                                        transition-hide="scale">
                                        <q-date class="q-ma-none q-pa-none" v-model="fecha_instalacion">
                                            <div class="row items-center justify-end q-ma-none q-pa-none">
                                                <q-btn v-close-popup label="Ok" color="primary"
                                                    class="q-ma-none q-pa-none" flat />
                                            </div>
                                        </q-date>
                                    </q-popup-proxy>
                                </q-icon>
                            </template>
                        </q-input>
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input prefix="$" dense v-model="costo_adquisicion" outlined label="Costo de Adquisición"
                            required mask="#.##" fill-mask="0" reverse-fill-mask input-class="text-right" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input prefix="$" dense v-model="costo_mensual" outlined label="Costo Mensual" required
                            mask="#.##" fill-mask="0" reverse-fill-mask input-class="text-right" />
                    </div>
                    <div class="col-12 col-md-6">
                        <q-input dense v-model="numero_serie" outlined label="Número de Serie" required />
                    </div>
                    <div class="col-12 col-md-6">
                        <q-input dense v-model="marca" outlined label="Marca" required />
                    </div>
                    <div class="col-12 col-md-6">
                        <q-input dense v-model="modelo" outlined label="Modelo" required />
                    </div>
                    <div class="col-12 col-md-6">
                        <q-input dense v-model="tipo" outlined label="Tipo" required />
                    </div>

                </q-card-section>

                <q-card-actions class="row justify-between">
                    <q-btn flat color="red" label="Cerrar" v-close-popup />
                    <q-btn flat color="primary" label="Asignar Localizador" @click="PostLocalizador()" />
                </q-card-actions>
            </q-card>
        </q-dialog>


        <div class="row q-pt-md q-col-gutter-md">
            <!-- Columna derecha: tabla ocupa más espacio si no hay formulario -->
            <div class="col-md-12 col-12'">
                <q-table dense title="Localizadores" class="shadow-1" :data="items" :loading="loading"
                    :columns="columns" color="primary" row-key="_id" :pagination="initialPagination">
                    <template v-slot:top-right>

                        <q-btn outline ref="" color="primary" icon="mdi-refresh" label="Consultar" no-caps
                            class="q-mr-sm q-my-md" @click="GetListaLocalizadores" />
                        <q-btn outline color="primary" icon="mdi-plus" label="Nuevo" class="q-my-md"
                            @click="nuevoItem()" />
                    </template>
                    <template v-slot:body="props">
                        <q-tr :props="props" class="hover-fila">
                            <q-td key="numero_serie" :props="props" @click="verItem(props.row)">{{
                                props.row.numero_serie
                                }}</q-td>
                            <q-td key="marca" :props="props" @click="verItem(props.row)">{{ props.row.marca }}</q-td>
                            <q-td key="modelo" :props="props" @click="verItem(props.row)">{{
                                props.row.modelo }}</q-td>
                            <q-td key="tipo" :props="props" @click="verItem(props.row)">{{
                                props.row.tipo }}</q-td>
                            <q-td key="fecha_compra" :props="props" @click="verItem(props.row)">{{
                                formatearFecha(props.row.fecha_compra) }}</q-td>
                            <q-td key="costo_adquisicion" :props="props" @click="verItem(props.row)">{{
                                formatoMonedaMexicana(props.row.costo_adquisicion)
                            }}</q-td>
                            <q-td key="costo_mensual" :props="props" @click="verItem(props.row)">{{
                                formatoMonedaMexicana(props.row.costo_mensual)
                            }}</q-td>
                            <q-td key="fecha_instalacion" :props="props" @click="verItem(props.row)">{{
                                formatearFecha(props.row.fecha_instalacion)
                            }}</q-td>
                            <q-td key="estatus" :props="props" @click="verItem(props.row)">
                                <q-badge v-if="props.row.estatus == 'Activo'" color="green" label="Activo" />
                                <q-badge v-if="props.row.estatus == 'Inactivo'" color="orange" label="Inactivo" />
                            </q-td>
                        </q-tr>
                    </template>
                </q-table>
            </div>
        </div>
    </q-page>
</template>

<script>
import axios from "axios";
import { QSpinnerClock } from 'quasar'

export default {
    data() {
        return {
            loading: false,
            items: [],
            columns: [
                { name: 'numero_serie', label: 'Número de Serie', field: 'numero_serie', align: 'center', sortable: true },
                { name: 'marca', label: 'Marca', field: 'marca', align: 'center', sortable: true },
                { name: 'modelo', label: 'Modelo', field: 'modelo', align: 'center', sortable: true },
                { name: 'tipo', label: 'Tipo', field: 'tipo', align: 'center', sortable: true },
                { name: 'fecha_compra', label: 'Fecha de Compra', field: 'fecha_compra', align: 'center', sortable: true },
                { name: 'costo_adquisicion', label: 'Costo de Adquisición', field: 'costo_adquisicion', align: 'center', sortable: true },
                { name: 'costo_mensual', label: 'Costo mensual', field: 'costo_mensual', align: 'center', sortable: true },
                { name: 'fecha_instalacion', label: 'Fecha de Instalación', field: 'fecha_instalacion', align: 'center', sortable: true },
                { name: 'estatus', label: 'Estatus', field: 'estatus', align: 'center', sortable: true }
            ],
            initialPagination: {
                sortBy: 'rfc',
                descending: false,
                page: 1,
                rowsPerPage: 10
            },
            clientes: [],
            selectCliente: null,
            dialogDetalles: false,
            selectAuto: null,
            autosCliente: [],
            listaAgencias: [],
            selectAgencia: null,

            numero_serie: '',
            marca: '',
            modelo: '',
            tipo: '',
            fecha_compra: '',
            costo_adquisicion: 0,
            costo_mensual: 0,
            fecha_instalacion: '',
            estatus: '',
            dialogVehiculo: false,
            auto: null

        };

    },
    computed: {

    },
    created() {
        this.GetClientes()
        this.GetProveedores()
        this.GetListaLocalizadores()
    },
    methods: {
        async verItem(item) {
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Consultando detalles. Espere...', messageColor: 'white' })
            try {
                let respuesa = await axios.get('Autos/GetAutosPorIdAutoDetalles/Localizador' + item._id_vehiculo)
                console.log(respuesa)
                this.auto = respuesa.data
            } catch (error) {
                console.log(error)
            }
            this.$q.loading.hide()
            this.dialogVehiculo = true

        },
        nuevoItem() {
            this.selectCliente = null;
            this.selectAuto = null;
            this.autosCliente = [];
            this.selectAgencia = null;
            this.dialogDetalles = true;
            this.numero_serie = '';
            this.marca = '';
            this.modelo = '';
            this.tipo = '';
            this.fecha_compra = '';
            this.costo_adquisicion = 0;
            this.costo_mensual = 0;
            this.fecha_instalacion = '';
            this.estatus = '';
        },
        async GetClientes() {
            try {
                let respuesa = await axios.get('Configuracion/GetUsuariosDatosFiscales/')
                // let respuesa = await axios.get('Login/GetClientes/')
                console.log(respuesa)
                this.clientes = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },

        async GetVehiculosPorClienteAsync() {
            if (!this.selectCliente) return;

            try {
                const res = await axios.get(`Autos/GetVehiculosPorClienteAsync/${this.selectCliente._id_cliente}`);
                // Puedes agregar campo "texto" al vuelo si quieres usarlo en option-label (opcional)
                console.log(res)
                this.autosCliente = res.data.map(auto => ({
                    ...auto,
                    texto: `${auto.marca} ${auto.modelo} (${auto.anio}) - ${auto.placa}`
                }));
            } catch (err) {
                console.error('Error al obtener autos:', err);
                this.autosCliente = [];
            }
        },
        async GetProveedores() {
            try {
                let respuesa = await axios.get('Catalogos/GetProveedoresTipo/Localizador')
                console.log(respuesa.data)
                this.listaAgencias = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetListaLocalizadores() {
            this.loading = true
            try {
                let respuesa = await axios.get('Autos/GetListaLocalizadores/')
                console.log(respuesa)
                this.items = respuesa.data
                this.loading = false
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },
        async PostLocalizador() {
            if (this.selectAuto == null) {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique el auto al que se le asignara el localizador.` });
                return
            }
            if (this.selectCliente == null) {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique el cliente al que se le haran los cargos.` });
                return
            }
            if (this.selectAgencia == null) {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique el Proveedor de su localizador.` });
                return
            }
            let objeto = {
                _id: '',
                _id_vehiculo: this.selectAuto,
                _id_proveedor: this.selectAgencia._id,
                proveedor: this.selectAgencia.razon_social,
                _id_cliente: this.selectCliente._id_cliente,
                numero_serie: this.numero_serie,
                marca: this.marca,
                modelo: this.modelo,
                tipo: this.tipo,
                fecha_compra: this.fecha_compra,
                fecha_instalacion: this.fecha_instalacion,
                estatus: 'Activo',
                costo_adquisicion: this.costo_adquisicion,
                costo_mensual: this.costo_mensual,
            }

            try {

                console.log(objeto)
                this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Asignando localizador. Espere...', messageColor: 'white' })

                const resp = await axios.post(`Autos/PostLocalizador/`, objeto);
                console.log(resp)

                this.$q.notify({ type: 'positive', position: 'top-right', message: `Se asigno correctamento el localizador al vehiculo.` });

                this.$q.loading.hide()

            } catch (error) {
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al asignar el localizador. Intentelo de nuevo...` });
                console.log(error)
            }
        },

        formatoMonedaMexicana(valor) {
            return valor.toLocaleString('es-MX', {
                style: 'currency',
                currency: 'MXN',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },

        formatearFecha(isoString) {
            const fecha = new Date(isoString);

            const dia = String(fecha.getUTCDate()).padStart(2, '0');
            const mes = String(fecha.getUTCMonth() + 1).padStart(2, '0');
            const anio = fecha.getUTCFullYear();

            const hora = String(fecha.getUTCHours()).padStart(2, '0');
            const minutos = String(fecha.getUTCMinutes()).padStart(2, '0');
            const segundos = String(fecha.getUTCSeconds()).padStart(2, '0');

            return `${dia}/${mes}/${anio}`;
        },
    }
};
</script>
<style>
.hover-fila:hover td {
    cursor: pointer;
    background: #dcf6ff;
}

.q-table thead,
[dir] .q-table tr,
[dir] .q-table th {
    border-color: #0094ca !important;
}

.doc-note {
    background-color: #f0f4f8;
    /* Fondo claro */
    border-left: 4px solid #007BFF;
    /* Línea de color azul en el borde izquierdo */
    padding: 16px;
    margin: 16px 0;
    border-radius: 8px;
    color: #333;
    /* Color de texto */
    font-family: Arial, sans-serif;
}

.doc-note__title {
    margin: 0 0 8px 0;
    font-weight: bold;
    color: #007BFF;
    /* Mismo tono del borde para coherencia */
    font-size: 16px;
}

.doc-note p {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
}
</style>